<script setup>
import LoxPagination from '@/components/helpers/LoxPagination.vue'
import WinLoxBet from '@/components/LoxBet/WinLoxBet.vue'
</script>

<template>
  <header>
    <h1>{{$language._l('bets.text_last_winners')}}</h1>
  </header>
  <p>{{$language._l('bets.welcome')}}</p>

  <table id="data-table">
    <thead>
    <tr>
      <th>{{$language._l('bets.field_user_name')}}</th>
      <th>{{$language._l('bets.events.field_title')}}</th>
      <th>{{$language._l('bets.field_bet_date')}}</th>
      <th>{{$language._l('bets.field_comments')}}</th>
    </tr>
    </thead>
    <tbody id="table-body">
      <win-lox-bet
        v-for="(win_bet, index) in bets"
        :win_bet="win_bet"
        :key="index"
      ></win-lox-bet>
    </tbody>
  </table>
  <lox-pagination
    v-if="show_pagination"
    :pagination_meta="pagination_meta"
    :prefix="'/' + id"
  ></lox-pagination>
</template>

<script>
export default {
  name: 'WinBetsWrapper',
  props: {
    id: {
      Number,
      default: 0,
      required: false
    },
    page: {
      type: [String, Number],
      required: false,
      default: 1
    },
    show_create:{
      type: [Boolean],
      required: false,
      default: true
    }

  },
	data() {
		return {
      'bets': [],
      'show_pagination': false,
      'pagination_meta': {}
		}
	},
	methods:
	{
    refreshLists()
    {
      const context = this;
      let url = 'win'
      if(this.page > 0){
        url = url + '/?page=' + this.page;
      }
      this.$resource.get(url).then(function(response) {
        context.bets = response.data?.data;
        context.show_pagination = response.data?.meta?.total > response.data?.meta?.per_page;
        context.pagination_meta = response.data?.meta;
      });
    }
	},
  mounted() {
    this.refreshLists()
  },
  watch: {
    page: function() { // watch it
      this.refreshLists();
    }
  }
}

</script>